import { render, staticRenderFns } from "./HuggyTabList.vue?vue&type=template&id=2d12806c"
import script from "./HuggyTabList.vue?vue&type=script&lang=js"
export * from "./HuggyTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports